import { Component,OnInit,OnChanges  ,Input,Output, EventEmitter,ChangeDetectionStrategy} from '@angular/core';
import { Observable, of } from 'rxjs';

import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-auto-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './auto-select.component.html',
})
export class AutoSelectComponent implements OnInit , OnChanges {

  @Output() emitValue = new EventEmitter();
  @Input() groupList: Group[];  //選單資料_來源
  filteredGroups$: Observable<Group[]>;  
  inputFormControl: FormControl;
  isSelect:boolean = false;
  value = ""

  ngOnInit() {   

    this.filteredGroups$ = of(this.groupList);
    this.inputFormControl = new FormControl();
  }

  ngOnChanges(){
    this.onClick()
    this.filteredGroups$ = of(this.groupList);
  }

  //失焦時 判斷是否已選並清除資料
  onBlur(){
    if(!this.isSelect){
        //清空資料
        this.value = ""
    }
    
    
    
  }

  //初始化資料
  onClick(){
    this.value=''
    this.isSelect = false
    this.emitValue.emit(null);
  }

  
  onSelect(e){
    this.emitValue.emit(e.value);
    this.isSelect = true
    
  }


  //選單過濾方法
  filter(value: string): Group[] {
    const filterValue = value.toLowerCase();
    if(filterValue.trim().length > 0){
      let glist = this.groupList.map(group => {
        let clist = group.child.filter(op => op.content.toLowerCase().includes(filterValue))
        return {
          id: group.id,
          name: group.name,
          child: clist
        }
      });
      let result = glist.filter(group => group.child.length)

      return result
    }
    else{
      return this.groupList
    }
    
  }
  //選單變化
  onModelChange(value: string) {
    this.filteredGroups$ = of(this.filter(value));
  }

}


interface Group {
  id: string;
  name: string;
  child: selectData[];
}

interface selectData {
  value: any;
  content: string;
  
}